var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
import { __awaiter, __decorate, __metadata } from "tslib";
import { Mutation, Action, VuexModule, Module } from 'vuex-module-decorators';
import ApiService from '@/core/services/ApiService';
import { Actions, Mutations } from '@/store/enums/finance/FunctionEnums';
let FunctionModule = class FunctionModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.wasFirstLoad = true;
        this.loading = false;
        this.loadPage = false;
        this.functionList = [];
        this.page = 1;
        this.size = 10;
        this.pageFilter = 1;
        this.wasLoadQuickFilter = true;
        this.desc = '';
        this.searchBy = '';
        this.paging = [];
        this.status = '';
        this.statusMessage = '';
        this.selectedFunctionName = [];
        this.dropdownlistFunctionCode = [];
        this.dropdownlistFunctionName = [];
    }
    get getFunctionWasFirstLoad() {
        return this.wasFirstLoad;
    }
    get getDropdownlistFunctionCode() {
        return this.dropdownlistFunctionCode;
    }
    get getDropdownlistFunctionName() {
        return this.dropdownlistFunctionName;
    }
    get getFunctionLists() {
        return this.functionList;
    }
    get getFunctionStatus() {
        const status = {
            status: this.status,
            statusMessage: this.statusMessage
        };
        return status;
    }
    get getSelectedFunctionName() {
        return this.selectedFunctionName;
    }
    get getFunctionPaging() {
        return this.paging;
    }
    get getFunctionLoading() {
        return this.loading;
    }
    get getStatusFunction() {
        const status = {
            status: this.status,
            statusMessage: this.statusMessage
        };
        return status;
    }
    get getFunctionSize() {
        return this.size;
    }
    get getFunctionWasLoadQuickFilter() {
        return this.wasLoadQuickFilter;
    }
    get getFunctionDesc() {
        return this.desc;
    }
    get getFunctionSearchBy() {
        return this.searchBy;
    }
    [_a = Mutations.SET_FUNCTION_LOAD](payload) {
        this.wasFirstLoad = payload;
    }
    [_b = Mutations.SET_SELECTED_FUNCTION_NAME](payload) {
        this.selectedFunctionName = payload;
    }
    [_c = Mutations.SET_FUNCTION_LIST](payload) {
        this.functionList = payload;
    }
    [_d = Mutations.SET_FUNCTION_LOADING](payload) {
        this.loading = payload;
    }
    [_e = Mutations.SET_FUNCTION_HANDLE_PAGE](payload) {
        this.page = payload;
    }
    [_f = Mutations.SET_FUNCTION_PAGE](payload) {
        this.paging = payload;
    }
    [_g = Mutations.SET_FUNCTION_LOAD_PAGE]() {
        this.loadPage = true;
    }
    [_h = Mutations.SET_FUNCTION_STATUS](payload) {
        this.status = payload.statusAssetNumber;
        this.statusMessage = payload.statusMessageAssetNumber;
    }
    [_j = Mutations.SET_DROPDOWNLIST_FUNCTION_CODE](payload) {
        this.dropdownlistFunctionCode = payload;
    }
    [_k = Mutations.SET_DROPDOWNLIST_FUNCTION_NAME](payload) {
        this.dropdownlistFunctionName = payload;
    }
    [_l = Mutations.SET_FUNCTION_SIZE](payload) {
        this.size = payload;
    }
    [_m = Mutations.SET_FUNCTION_HANDLE_SIZE](payload) {
        this.size = payload;
    }
    [_o = Mutations.SET_FUNCTION_PAGE_FILTER](payload) {
        this.pageFilter = payload;
    }
    [_p = Mutations.SET_FUNCTION_WAS_LOAD_QUICK_FILTER](payload) {
        this.wasLoadQuickFilter = payload;
    }
    [_q = Mutations.SET_FUNCTION_DESC](payload) {
        this.desc = payload;
    }
    [_r = Mutations.SET_FUNCTION_SEARCH_BY](payload) {
        this.searchBy = payload;
    }
    [_s = Actions.GET_FUNCTION_LIST]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_FUNCTION_LOADING, false);
            const params = {
                ver: 'v1'
            };
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/function/filter?` +
                new URLSearchParams(params).toString();
            const paramsData = {
                Page: this.page.toString(),
                Size: this.size.toString(),
                functionName: this.selectedFunctionName,
                isActive: true
            };
            return new Promise((resolve, reject) => {
                ApiService.post(url, paramsData)
                    .then((res) => {
                    var _y, _z;
                    if (res.status === 200) {
                        this.context.commit(Mutations.SET_FUNCTION_LIST, ((_y = res.data.result.content) === null || _y === void 0 ? void 0 : _y.data) || []);
                        this.context.commit(Mutations.SET_FUNCTION_LOAD_PAGE, true);
                        this.context.commit(Mutations.SET_FUNCTION_PAGE, ((_z = res.data.result.content) === null || _z === void 0 ? void 0 : _z.paging) || {
                            currentPage: 0,
                            totalPages: 0,
                            totalElements: 0,
                            errorRows: 0,
                            readyToUpload: 0
                        });
                        this.context.commit(Mutations.SET_FUNCTION_LOADING, false);
                        resolve(true);
                    }
                    else {
                        this.context.commit(Mutations.SET_FUNCTION_LOADING, false);
                        reject(false);
                    }
                })
                    .catch((err) => {
                    reject(false);
                });
            });
        });
    }
    [_t = Actions.GET_FUNCTION_LIST_ALLDATA]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_FUNCTION_WAS_LOAD_QUICK_FILTER, false);
            const params = {
                ver: 'v1'
            };
            const dataListFunctionCode = [...this.dropdownlistFunctionCode];
            const dataListFunctionName = [...this.dropdownlistFunctionName];
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/function/filter?` +
                new URLSearchParams(params).toString();
            const paramsData = {
                Page: this.pageFilter.toString(),
                Size: '10',
                Desc: this.desc,
                SearchBy: this.searchBy,
                isActive: true
            };
            return new Promise((resolve, reject) => {
                ApiService.post(url, paramsData)
                    .then((res) => {
                    if (res.status === 200) {
                        if (res.data.result.content !== null) {
                            if (res.data.result.content.paging.totalPages === this.pageFilter) {
                                this.context.commit(Mutations.SET_FUNCTION_WAS_LOAD_QUICK_FILTER, false);
                            }
                            else {
                                this.context.commit(Mutations.SET_FUNCTION_WAS_LOAD_QUICK_FILTER, true);
                            }
                            res.data.result.content.data.map((data) => {
                                dataListFunctionCode.push({
                                    value: data.functionCode,
                                    label: data.functionCode
                                });
                                dataListFunctionName.push({
                                    value: data.functionName,
                                    label: data.functionName
                                });
                            });
                        }
                        else {
                            this.context.commit(Mutations.SET_FUNCTION_WAS_LOAD_QUICK_FILTER, false);
                        }
                        this.context.commit(Mutations.SET_DROPDOWNLIST_FUNCTION_CODE, dataListFunctionCode);
                        this.context.commit(Mutations.SET_DROPDOWNLIST_FUNCTION_NAME, dataListFunctionName);
                        resolve(true);
                    }
                    else {
                        this.context.commit(Mutations.SET_FUNCTION_WAS_LOAD_QUICK_FILTER, false);
                        reject(false);
                    }
                })
                    .catch((err) => {
                    this.context.commit(Mutations.SET_FUNCTION_WAS_LOAD_QUICK_FILTER, false);
                    reject(false);
                });
            });
        });
    }
    [_u = Actions.UPDATE_FUNCTION_SIZE](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_FUNCTION_SIZE, data);
            this.context.commit(Mutations.SET_FUNCTION_HANDLE_PAGE, 1);
            this.context.dispatch(Actions.GET_FUNCTION_LIST);
        });
    }
    [_v = Actions.UPDATE_FUNCTION_PAGE_FILTER]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_FUNCTION_PAGE_FILTER, this.pageFilter + 1);
        });
    }
    [_w = Actions.UPDATE_FUNCTION_CODE](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_FUNCTION_SEARCH_BY, data === '' ? '' : 'functioncode');
            this.context.commit(Mutations.SET_FUNCTION_DESC, data);
            this.context.commit(Mutations.SET_DROPDOWNLIST_FUNCTION_CODE, []);
            this.context.commit(Mutations.SET_DROPDOWNLIST_FUNCTION_NAME, []);
            this.context.commit(Mutations.SET_FUNCTION_PAGE_FILTER, 1);
            this.context.dispatch(Actions.GET_FUNCTION_LIST_ALLDATA);
        });
    }
    [_x = Actions.UPDATE_FUNCTION_DESC](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_FUNCTION_SEARCH_BY, data === '' ? '' : 'functionname');
            this.context.commit(Mutations.SET_FUNCTION_DESC, data);
            this.context.commit(Mutations.SET_DROPDOWNLIST_FUNCTION_CODE, []);
            this.context.commit(Mutations.SET_DROPDOWNLIST_FUNCTION_NAME, []);
            this.context.commit(Mutations.SET_FUNCTION_PAGE_FILTER, 1);
            this.context.dispatch(Actions.GET_FUNCTION_LIST_ALLDATA);
        });
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], FunctionModule.prototype, _a, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], FunctionModule.prototype, _b, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], FunctionModule.prototype, _c, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], FunctionModule.prototype, _d, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], FunctionModule.prototype, _e, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], FunctionModule.prototype, _f, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], FunctionModule.prototype, _g, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], FunctionModule.prototype, _h, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], FunctionModule.prototype, _j, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], FunctionModule.prototype, _k, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], FunctionModule.prototype, _l, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], FunctionModule.prototype, _m, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], FunctionModule.prototype, _o, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], FunctionModule.prototype, _p, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], FunctionModule.prototype, _q, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], FunctionModule.prototype, _r, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], FunctionModule.prototype, _s, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], FunctionModule.prototype, _t, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], FunctionModule.prototype, _u, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], FunctionModule.prototype, _v, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], FunctionModule.prototype, _w, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], FunctionModule.prototype, _x, null);
FunctionModule = __decorate([
    Module
], FunctionModule);
export default FunctionModule;
